<template>
    <div class="course-container">
        <!-- 顶部导航栏 -->
        <div class="top-nav">
            <div class="back-container" @click="changeModel">
                <el-icon :size="16"><ArrowLeftBold /></el-icon>
                <span>返回</span>
            </div>
            <div class="top-nav-title text-one" :title="form.courseName">{{ form.courseName }}</div>
        </div>

        <el-row class="course-main">
            <!-- 左侧操作栏 -->
            <el-col :span="1">
                <div class="side-bar" @click="isMl = false">
                    <div class="side-item cursor" :class="{ 'side-item-active': isMl }" @click.stop="isMl = !isMl">
                        <img v-if="!isMl" src="../../assets/image/video-zj.png" alt="">
                        <img v-else src="../../assets/image/video-zjAc.png" alt="">
                        <div class="side-item-label">章节</div>
                    </div>
                    <div class="side-item cursor" @click="tofileShow(activeVideo)">
                        <img class="side-item-img-lg" src="../../assets/image/video-file.png" alt="">
                        <div class="side-item-label">资料</div>
                    </div>
                    <div class="side-item cursor" :class="{ 'side-item-active': form.isCollect == 1 }" @click="toIsColledt">
                        <img v-if="form.isCollect == 0" class="side-item-img-lg" src="../../assets/image/collect.png" alt="">
                        <img v-else class="side-item-img-lg" src="../../assets/image/collect-blue.png" alt="">
                        <div :title="form.collectCount" class="side-item-label text-one">收藏{{ form.collectCount }}</div>
                    </div>
                    <div class="side-item cursor" :class="{ 'side-item-active': form.isLike }" @click="toIsLike">
                        <img v-if="!form.isLike" src="../../assets/image/dz.png" alt="">
                        <img v-else src="../../assets/image/dz-blue.png" alt="">
                        <div :title="form.likeCount" class="side-item-label text-one">点赞{{ form.likeCount }}</div>
                    </div>
                </div>
            </el-col>

            <!-- 章节目录（悬浮面板） -->
            <el-col class="btx" :class="{ 'btx-hide': !isMl }" :span="10">
                <div id="vdWidth" class="custtoo chapter-panel">
                    <div class="chapter-panel-header">章节目录</div>
                    <div class="chapter-panel-body">
                        <el-tree :data="dataSource" highlight-current ref="tree" @node-click="changeTree"
                                 :props="{ label: 'courseName', id: 'courseId', children: 'childrenList' }" node-key="courseId"
                                 default-expand-all :expand-on-click-node="false">
                            <template #default="{ node, data }">
                                <div class="custom-tree-node" style="display: flex;">
                                    <div style="flex: 1;align-items: center; display: flex;" :title="node.label">
                                        <el-icon :size="17" v-if="data.videoList && data.videoList.length != 0">
                                            <VideoPlay /> &nbsp;
                                        </el-icon>
                                        <div :style="'width:' + (vdWidth - 150) + 'px;'" class="text-one" style="">{{ node.label
                                            }}
                                        </div>
                                    </div>
                                    <div v-if="isLook == 0">
                                        <a title="新增视频" v-if="isType == node.level" style="margin-left: 8px"
                                           @click.stop="addVideo(data)"><el-icon :size="17">
                                            <FolderAdd />
                                        </el-icon></a>
                                        <a title="新增" v-if="node.level != 3 && (isVideo == 0 ? true : (isVideo != node.level))"
                                           style="margin-left: 8px" @click.stop="append(data)"><el-icon :size="17">
                                            <Plus />
                                        </el-icon></a>
                                        <a title="编辑" style="margin-left: 8px" @click.stop="editCourse(data)"><el-icon
                                          :size="17">
                                            <EditPen />
                                        </el-icon></a>
                                        <el-popconfirm confirm-button-text="是" cancel-button-text="否" :icon="InfoFilled"
                                                       icon-color="#626AEF" title="确定删除该章节及其视频附件" @confirm="delCourse(node, data)">
                                            <template #reference>
                                                <a title="删除" v-if="node.level != 1" style="margin: 0 8px"> <el-icon :size="17">
                                                    <Delete />
                                                </el-icon></a>
                                            </template>
                                        </el-popconfirm>
                                    </div>
                                </div>
                            </template>
                        </el-tree>
                    </div>
                </div>
            </el-col>

            <!-- 视频与评论区 -->
            <el-col :span="17" @click="isMl = false">
                <el-card shadow="never" class="video-card">
                    <div id="videoWidth" class="ci-video-box">
                        <video id="videoElementQb" v-if="isshow"
                               :poster="activeVideo.videoUrl + '?x-oss-process=video/snapshot,t_1,m_fast'" preload="none"
                               controls="controls" style="width: 100%;height: 100%;display: block;" controlsList="nodownload"
                               :src="activeVideo.videoUrl"></video>
                    </div>
                    <el-scrollbar class="mt10" v-if="isshow">
                        <div class="node-tag-list">
                            <el-tag @click="tdNose(item)" class="mr5 cursor" type="info" v-for="item in vdNodeList">
                                <span class="node-tag-name mr5">{{ item.nodeName }}</span>{{ item.nodeDateTime }}
                            </el-tag>
                        </div>
                    </el-scrollbar>
                    <div class="comment-header">
                        <el-icon :size="18">
                            <ChatDotSquare />
                        </el-icon>
                        <span>评论 {{ (activeVideo.commentList && activeVideo.commentList.length) || 0 }}</span>
                    </div>
                    <div>
                        <dataEmpty v-if="activeVideo.commentList && activeVideo.commentList.length == 0"
                                  title="暂无评论" />
                        <div v-for="(item, index) in activeVideo.commentList" class="comment-item">
                            <div class="comment-item-top">
                                <div class="comment-user">
                                    <el-avatar :size="32" :src="item.avatar" />
                                    <div class="comment-user-name">{{ item.trueName }}</div>
                                </div>
                                <div class="comment-del cursor" v-if="userId == item.userId">
                                    <el-popconfirm confirm-button-text="是" cancel-button-text="否" :icon="InfoFilled"
                                                   icon-color="#626AEF" title="确定确定删除该评论" @confirm="toDel(item, index)">
                                        <template #reference>
                                            <el-icon>
                                                <Delete />
                                            </el-icon>
                                        </template>
                                    </el-popconfirm>
                                </div>
                            </div>
                            <div class="comment-content">
                                {{ item.content }}
                            </div>
                            <div class="comment-time">
                                {{ timestampToTime(item.commentTime) }}
                            </div>
                        </div>
                    </div>
                    <div class="comment-input zsss">
                        <el-input v-model="content" placeholder="添加评论">
                            <template #append>
                                <div class="cursor comment-send" @click="toContent">
                                    <el-icon :size="20">
                                        <Position />
                                    </el-icon>
                                </div>
                            </template>
                        </el-input>
                    </div>
                </el-card>
            </el-col>

            <!-- 右侧课程信息 -->
            <el-col :span="6" @click="isMl = false">
                <div class="info-panel">
                    <div class="info-user">
                        <el-avatar :size="40" :src="form.userAvatar + '?_=' + Date.now()" />
                        <div class="info-user-name text-one" :title="form.userName">{{ form.userName }}</div>
                    </div>
                    <div class="info-recommend">{{ form.courseRecommend }}</div>
                    <div class="info-section-title">视频</div>
                    <div class="ci-video-item cursor" v-for="item in activeObj.videoList" :key="item.videoId"
                         :class="{ 'ci-video-item-active': activeVideo.videoId == item.videoId }"
                         @click="getActiveObj(item)">
                        <div class="ci-video-item-cover">
                            <img class="csvideo" :src="item.videoUrl + '?x-oss-process=video/snapshot,t_1,m_fast'"
                                 alt="">
                        </div>
                        <div class="ci-video-item-title text-one" :title="item.videoTitle">{{ item.videoTitle }}</div>
                    </div>
                </div>
            </el-col>
        </el-row>

        <el-dialog draggable :title="'附件'" v-model="fileShow" width="80%">
            <div class="ci-file-list">
                <div @click="xz(item)" v-for="item in showFileList" class="ci-file-item csbbb cursor">
                    <el-icon :size="20" v-has-btn="'1,2'" @click.stop="handleDownload(item)" title="下载" class="eicon">
                        <Download />
                    </el-icon>
                    <img class="ci-file-item-img" :src="item.imgUrl + '/1.png'" alt="">
                    <div class="ci-file-item-name text-one" :title="item.fileName">{{ item.fileName }}</div>
                </div>
            </div>
            <div style="width: 100%;" v-if="showFileList.length == 0">
                <el-empty class="qun-empty" description="暂无附件" />
            </div>
        </el-dialog>
    </div>
</template>
<script>
import flvjs from 'flv.js/dist/flv.min.js'
import { ElMessageBox } from 'element-plus'

import { famousCourseCreate, famousCourseInfo, famousCourseUpdate,
    famousCourseDel, famousCourseDeleteVideo, famousCourseView, likeClick,
    commentCreate, commentDelete, addOrCancel, videoNodeList } from "@/api/admin/famousCourse"
import { download } from "@/api/adminservice/public";
import { timestampToTime } from "@/utils/date";
import dataEmpty from "@/components/dataEmpty.vue";

export default {
    name: "courseInfo",
    components: {dataEmpty},
    props:{
        courseId:{
            type: String,
            default:null
        },
        classify:{
            type: String,
            default:null
        },
    },
    watch:{
        courseId(newValue,oldValue){
            this.getfamousCourseInfo()
            this.form = {}
            this.activeVideo.videoUrl = ''
        },
        classify(newValue,oldValue){
            this.stageType = newValue
            this.getfamousCourseInfo()
            this.form = {}
            this.activeVideo.videoUrl = ''
        }
    },
    data() {
        return {
            showMode:'page',
            vdNodeList: [],
            timestampToTime,
            isshow: false,
            isMl: false,
            userId: '',
            content: '',
            activeVideo: {
                videoUrl: ''
            },
            userHeadImg: '',
            isLook: 1,
            isFamous: 1,
            isCollection: 0,
            isStudio: 0,
            isTeachStudio: 0,
            isStudioRoom: 0,
            isTraVourse: 0,
            isList: 1,
            isVideo: 0,// 1 课 2 章 3 节
            isType: 1, // 1 课 2 章 3 节
            addFileShow: false,
            showFileList: [],
            fileShow: false,
            addVideoShow: false,
            addVideoCourseId: '',
            addVideoId: '',
            appCourseRules: {
                name: [
                    { required: true, message: "请输入章节名称", trigger: "blur" }
                ],
            },
            appCourseShow: false,
            appCourseForm: {
                name: '',
                parentId: ''
            },
            fileList: [],
            treedata: [],
            dataSource: [],
            periodList: [],
            gradeList: [],
            subjectList: [],
            courseClassifyList: [],
            activeObj: {},
            userList: [],
            token: this.$storage.get("token"),
            // 遮罩层
            loading: true,
            // 非单个禁用
            single: true,
            editCourseShow: false,
            // 表单参数
            form: {
                periodKey: '',
                gradeKey: '',
                subjectKey: '',
                lessonLevelKey: '',
                title: '',
                leadUser: '',
                teamUsers: '',
                teamuseList: [],
            },
            vdWidth: 250,
            // 表单校验
            rules: {},
            delFileList: [],
            trainId: '',
            stageType: 3,
            flvPlayer: null,
            videoHeight:500,
        };
    },
    created() {},
    mounted() {
        this.userId = JSON.parse(this.$storage.get("userInfo")).userId
        this.getfamousCourseInfo()
    },
    unmounted() {},
    computed: {},
    methods: {
        changeModel(){
            this.$emit('change-mode', this.showMode);
        },
        handleDownload(item) {
            console.log(item);
            download(item.fileUrl, item.fileName)
        },
        toDel(item, index) {
            commentDelete({ commentId: item.commentId }).then(res => {
                if (res.data.code == 1) {
                    this.activeVideo.commentList.splice(index, 1)
                    this.$message.success("删除成功");
                } else {
                    this.$message.error("操作失败");
                }
            })
            console.log(item, index);
        },
        toContent() {
            if (this.content == '') {
                this.$message.error("请输入评论内容")
                return;
            }
            console.log(this.activeVideo);
            commentCreate({ content: this.content, relationId: this.activeVideo.videoId }).then(res => {
                if (res.data.code == 1) {
                    this.content = '';
                    this.activeVideo.commentList.unshift(res.data.data)
                    this.$message.success("评论成功");
                } else {
                    this.$message.error(res.data.msg)
                }
            })
        },
        toIsLike() {
            // if (!this.form.isLike) {
            likeClick({ relationId: this.form.courseId }).then(res => {
                if (res.data.code == 1) {
                    if (this.form.isLike == 1) {
                        this.$message.success("取消点阵");
                        this.form.isLike = 0;
                        this.form.likeCount = this.form.likeCount - 1;
                    } else {
                        this.$message.success("点赞成功");
                        this.form.isLike = 1;
                        this.form.likeCount = this.form.likeCount + 1;
                    }
                    // this.getfamousCourseInfo()
                } else {
                    this.$message.error("操作失败")
                }
            })
            // }
        },
        toIsColledt() {
            addOrCancel({ collectType: this.isFamous ? 1 : 2, relationId: this.form.courseId }).then(res => {
                if (res.data.code == 1) {
                    if (this.form.isCollect == 1) {
                        this.$message.success("取消收藏");
                        this.form.isCollect = 0;
                        this.form.collectCount = this.form.collectCount - 1;
                    } else {
                        this.$message.success("收藏成功");
                        this.form.isCollect = 1;
                        this.form.collectCount = this.form.collectCount + 1;
                    }
                } else {
                    this.$message.error("操作失败")
                }
            })
            // }else{

            // }
        },
        tdNose(item) {
            this.flvPlayer.currentTime = item.nodeTime;
        },
        getVnList() {
            this.vdNodeList = []
            if (this.activeVideo.videoId) {
                videoNodeList({ videoId: this.activeVideo.videoId }).then(res => {
                    this.vdNodeList = res.data.data;
                    this.vdNodeList.forEach(e => {
                        var time = this.fdsfs(e.nodeTime).split(':')
                        e.nodeDateTime = time[0] + ':' + time[1] + ':' + time[2]
                    })
                })
            }
        },
        getActiveObj(item) {
            this.flvPlayer.pause()
            this.flvPlayer.unload()
            this.flvPlayer.detachMediaElement()
            this.flvPlayer.destroy()
            this.flvPlayer = null
            this.isshow = false;
            this.activeVideo = item;
            this.getVnList()

            setTimeout(() => {
                this.isshow = true;
                console.log(this.activeVideo);
                setTimeout(() => {
                    var videoElement = document.getElementById('videoElementQb');
                    console.log(videoElement);
                    var videoType = this.activeVideo.videoUrl.substring(this.activeVideo.videoUrl.length - 3).toLowerCase()
                    this.flvPlayer = flvjs.createPlayer({
                          type: videoType,
                          isLive: true,
                          hasAudio: true,
                          url: this.activeVideo.videoUrl
                      },
                      {
                          enableWorker: false, //不启用分离线程
                          enableStashBuffer: false, //关闭IO隐藏缓冲区
                          reuseRedirectedURL: true, //重用301/302重定向url，用于随后的请求，如查找、重新连接等。
                          autoCleanupSourceBuffer: false //自动清除缓存
                      })
                    this.flvPlayer.attachMediaElement(videoElement);
                    this.flvPlayer.load();
                    // this.flvPlayer.play();
                })
            })
            console.log(item);

        },
        delFile(item) {
            console.log(item);
            var _this = this;
            ElMessageBox.confirm(
              '是否删除该视频及附件?',
              '删除',
              {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning',
              }
            ).then(() => {
                famousCourseDeleteVideo({ videoId: item.videoId }).then(res => {
                    if (res.data.code == 1) {
                        this.$message.success("删除成功");
                        this.getfamousCourseInfo()
                        // this.$emit('isTg', true);
                    } else {
                        this.$message.error("操作失败")
                    }
                })

            }).catch(() => {

            })

            console.log(item);
        },
        xz(item) {
            let routeUrl = this.$router.resolve({
                path: '/lessonFileDetail',// 这里的路径就可以正常的写，不需要添加_blank: true
                query: { data: JSON.stringify(item) }
            })
            window.open(routeUrl.href, '_blank')
            // download(item.fileUrl, item.fileName)
        },
        tofileShow(item) {
            this.showFileList = item.fileList;
            this.fileShow = true;
        },
        addFile(item) {
            // console.log(item);
            this.addVideoId = item.videoId
            this.fileList = [];
            this.addFileShow = true;
        },
        changeTree(data) {
            console.log(data);
            this.activeObj = data;
        },
        fdsfs(ss) {
            var hh = 0;
            var mm = 0;
            var ss = ~~ss;// 秒
            if (ss > 3599) {
                hh = Math.floor(ss / 3600);
                mm = Math.floor(ss % 3600 / 60);
                ss = ss % 60;
                return (hh > 9 ? hh : '0' + hh) + ":" + (mm > 9 ? mm : '0' + mm) + ":" + (ss > 9 ? ss : '0' + ss);
            } else if (ss > 59) {
                mm = Math.floor(ss / 60);
                ss = ss % 60;
                return "00:" + (mm > 9 ? mm : '0' + mm) + ":" + (ss > 9 ? ss : '0' + ss);
            } else {
                return "00:00:" + (ss > 9 ? ss : '0' + ss);
            }
        },
        append(data) {
            this.appCourseForm = {
                name: '',
                parentId: data.courseId
            }
            if (data.videoList.length != 0) {
                this.$message.error('该层有视频，无法创建下级')
            } else {
                this.appCourseShow = true;
            }

            // famousCourseChapter({
            //     name: '节点111',
            //     parentId: data.courseId
            // }).then(res => {

            // })
            console.log(data);
        },
        addVideo(data) {
            console.log(data);
            this.fileList = [];
            if (data.childrenList) {
                if (data.childrenList.length == 0) {
                    this.addVideoCourseId = data.courseId
                    this.addVideoShow = true;
                } else {
                    this.$message.error('请在最下一级添加视频')
                }
            } else {
                this.addVideoCourseId = data.courseId
                this.addVideoShow = true;
            }


        },
        editCourse(data) {
            this.appCourseForm = {
                name: data.courseName,
                parentId: data.courseId
            }
            this.editCourseShow = true;
        },
        delCourse(node, data) {
            console.log(node, data);
            famousCourseDel({ courseId: data.courseId }).then(res => {
                if (res.data.code == 1) {
                    this.$message.success("删除成功");
                    this.getfamousCourseInfo()
                } else {
                    this.$message.error("操作失败")
                }
            })
        },
        remove(node, data) {
            console.log(node, data);
        },
        checkCoverValidator(rule, value, callback) {
            if (this.form.courseCover != '') {
                callback()
            } else {
                callback(new Error('请上传封面'))
            }
        },
        getfamousCourseInfo() {
            if (this.courseId!==null&&this.courseId!==undefined&&this.courseId!==''){
                delete this.activeObj.videoList
                this.isType = 1;
                this.isVideo = 0;
                this.dataSource = [];
                famousCourseInfo({ courseId: this.courseId,isTraVourse:this.isTraVourse}).then(res => {
                    this.form = res.data.data;
                    famousCourseView({ courseId: this.form.courseId }).then(res => {})
                    this.dataSource.push(this.form)
                    if (this.isLook == 0) {
                        var isz = false;
                        var isj = false;
                        if (this.form.videoList.length != 0) {
                            this.isVideo = 1;
                        } else {
                            this.isVideo = 0;
                        }
                        if (this.form.childrenList) {
                            this.form.childrenList.forEach(j => {
                                if (j.videoList.length != 0) {
                                    this.isVideo = 2;
                                }
                                if (j.childrenList) {
                                    j.childrenList.forEach(m => {
                                        if (m.videoList.length != 0) {
                                            this.isVideo = 3;
                                        }
                                        isj = true;
                                    })
                                } else {
                                    isz = true;
                                }

                            })
                        } else {

                        }
                        if (isj == true) {
                            this.isType = 3;
                        } else {
                            if (isz == true) {
                                this.isType = 2;
                            }
                        }
                        console.log(this.dataSource);
                        if (this.activeObj.courseId) {
                            // this.form.forEach(e => {
                            if (this.form.childrenList) {
                                this.form.childrenList.forEach(j => {
                                    if (j.childrenList) {
                                        j.childrenList.forEach(m => {
                                            if (m.courseId == this.activeObj.courseId) {
                                                this.activeObj = m;
                                            }
                                            if (m.videoList && m.videoList.length != 0) {

                                            }
                                        })
                                    }
                                    if (j.videoList && j.videoList.length != 0) {

                                    }
                                    if (j.courseId == this.activeObj.courseId) {
                                        this.activeObj = j;
                                    }
                                })
                            }

                            if (this.form.courseId == this.activeObj.courseId) {
                                this.activeObj = this.form;
                            }
                            if (this.activeObj.videoList) {

                            } else {
                                this.activeObj = this.dataSource[0]
                            }
                            // })
                            this.$nextTick(() => {
                                this.$refs.tree.setCurrentKey(this.activeObj.courseId);
                            });
                        } else {
                            this.$nextTick(() => {
                                this.$refs.tree.setCurrentKey(this.dataSource[0].courseId);
                                this.activeObj = this.dataSource[0]
                            });
                        }
                    } else if (this.isLook == 1) {
                        if (this.form.videoList.length != 0) {
                            this.$nextTick(() => {
                                this.$refs.tree.setCurrentKey(this.dataSource[0].courseId);
                            });
                            this.activeObj = this.dataSource[0]
                            this.activeVideo = this.dataSource[0].videoList[0]

                        } else {
                            if (this.form.childrenList) {
                                try {
                                    this.form.childrenList.forEach(j => {
                                        if (j.childrenList) {
                                            j.childrenList.forEach(m => {
                                                if (m.courseId == this.activeObj.courseId) {
                                                    this.activeObj = m;
                                                    this.activeVideo = m.videoList[0]

                                                }
                                                if (m.videoList && m.videoList.length != 0) {
                                                    console.log(m.courseId);
                                                    this.activeObj = m;
                                                    this.activeVideo = m.videoList[0]

                                                    this.$nextTick(() => {
                                                        // selectId：绑定的 node-key
                                                        this.$refs.tree.setCurrentKey(m.courseId);
                                                    });
                                                    throw new Error()
                                                }
                                            })
                                        }
                                        if (j.videoList && j.videoList.length != 0) {
                                            console.log(j.courseId);
                                            this.activeObj = j;
                                            this.activeVideo = j.videoList[0]
                                            this.$nextTick(() => {
                                                // selectId：绑定的 node-key
                                                this.$refs.tree.setCurrentKey(j.courseId);
                                            });
                                            throw new Error()
                                        }
                                    })
                                } catch (error) {
                                    console.log(error);
                                }

                            }
                        }
                        this.getVnList()
                    }
                    setTimeout(() => {
                        this.isshow = true;
                        setTimeout(() => {
                            var videoElement = document.getElementById('videoElementQb');
                            console.log(videoElement);
                            console.log(this.activeVideo);
                            var videoType = this.activeVideo.videoUrl.substring(this.activeVideo.videoUrl.length - 3).toLowerCase()

                            this.flvPlayer = flvjs.createPlayer({
                                  type: videoType,
                                  isLive: true,
                                  hasAudio: true,
                                  url: this.activeVideo.videoUrl
                              },
                              {
                                  enableWorker: false, //不启用分离线程
                                  enableStashBuffer: false, //关闭IO隐藏缓冲区
                                  reuseRedirectedURL: true, //重用301/302重定向url，用于随后的请求，如查找、重新连接等。
                                  autoCleanupSourceBuffer: true //自动清除缓存
                              })
                            this.flvPlayer.attachMediaElement(videoElement);
                            this.$forceUpdate()
                            this.flvPlayer.load();
                            // this.flvPlayer.play();
                        }, 1000)

                    }, 500);

                })
            }


        },
        handleXTChange(file) {
            console.log(file)
        },
        handleJAChange(file) {
            console.log(file)
        },
        handleXAChange(file) {
            console.log(file);
        },
        handleKjChange(file) {
            console.log(file)

        },
        beforeJAUpload(rawFile) {
            console.log(rawFile)
            if (!(rawFile.type == 'application/pdf' || rawFile.type == 'application/vnd.ms-powerpoint' || rawFile.type == 'application/vnd.openxmlformats-officedocument.presentationml.presentation')) {
                this.$message.error('文件必须是.pdf,.ppt,.pptx格式的')
                return false
            } else if (rawFile.size / 1024 / 1024 > 200) {
                this.$message.error('文件大小不能超过200M')
                return false
            }
            return true
        },
        startDateConfirm(e) {
            if (e > this.form.endTime) {
                this.form.endTime = '';
            }
        },
        endDateConfirm(e) {
            console.log(e,)
            if (e < this.form.beginTime) {
                this.form.beginTime = '';
            }
        },
        checkValidator(rule, value, callback) {
            if (this.form.beginTime === '' || !this.form.beginTime) {
                callback(new Error('请选择开始日期'))
            } else if (this.form.endTime === '' || !this.form.endTime) {
                callback(new Error('请选择结束日期'))
            } else {
                callback()
            }
        },
        disabledDate(current) {
            return current && current < Number(new Date()) - 86400000
        },
        enddisabledDate(current) {
            if (this.form.beginTime) {
                return current && current < this.form.beginTime
            } else {
                return current && current < Number(new Date()) - 86400000
            }
        },
        changePeriod() {
            this.form.gradeKey = '';
            this.form.subjectKey = '';
            this.gradeList = [];
            this.subjectList = [];
            this.periodList.forEach(j => {
                if (this.form.periodKey == j.dictKey) {
                    this.gradeList = j.childrenList;
                }
            })
        },
        changeGrade() {
            this.form.subjectKey = '';
            this.subjectList = []
            this.periodList.forEach(e => {
                if (this.form.periodKey == e.dictKey) {
                    e.childrenList.forEach(j => {
                        if (this.form.gradeKey == j.dictKey) {
                            this.subjectList = j.childrenList;
                        }
                    })
                }
            })
        },
        getQueryDict() {},
        handleAvatarSuccess(response, uploadFile) {
            console.log(response, uploadFile);
            if (uploadFile.response.code == 1) {
                this.form.courseCover = uploadFile.response.data;
            } else {
                this.$message.error("上传失败")
            }

        },
        beforeAvatarUpload(rawFile) {
            console.log(rawFile)
            if (!(rawFile.type == 'image/jpeg' || rawFile.type == 'image/png' || rawFile.type == 'image/jpg')) {
                this.$message.error('图片必须是jpeg、png、jpg格式的')
                return false
            } else if (rawFile.size / 1024 / 1024 > 10) {
                this.$message.error('图片大小不能超过10M')
                return false
            }
            return true
        },
        /** 提交按钮 */
        submitForm() {
            console.log(this.form)

            this.$refs["form"].validate(valid => {
                if (valid) {
                    if (this.courseId) {
                        famousCourseUpdate(this.form).then(res => {
                            if (res.data.code == 1) {
                                this.$message.success("编辑成功");
                                this.replace('/famousCourse', { isSx: 1 })
                            } else {
                                this.$message.error("操作失败")
                            }
                        })
                    } else {
                        famousCourseCreate(this.form).then(res => {
                            if (res.data.code == 1) {
                                this.$message.success("新增成功");
                                this.replace('/famousCourse', { isSx: 1 })
                                // this.$emit('isTg', true);
                            } else {
                                this.$message.error("操作失败")
                            }

                        });
                    }

                }
            });
        },
        // 取消按钮
        cancel() {
            if (this.isCollection == 1) {
                this.replace('/collectionCenter', { isSx: 1 })
            } else {
                if (this.isStudio == 1) {
                    this.replace('/studioManage')
                }
                if (this.isTeachStudio == 1) {
                    this.replace('/teachStudioManage')
                }
                if (this.isStudioRoom == 1) {
                    this.replace('/studioinfo', { groupId: this.$route.query.groupId })
                }
                if (this.isFamous == 1) {
                    if (this.isList == 0) {
                        this.replace('/famousCourse', { isSx: 1 })
                    } else {
                        if (this.stageType == 1) {
                            this.replace('/famousGspList', { isSx: 1, stageType: this.stageType })
                        } else if (this.stageType == 2) {
                            this.replace('/famousQbList', { isSx: 1, stageType: this.stageType })
                        } else if (this.stageType == 3) {
                            this.replace('/famousJbList', { isSx: 1, stageType: this.stageType })
                        } else if (this.stageType == 4) {
                            this.replace('/famousKhList', { isSx: 1, stageType: this.stageType })
                        }

                    }
                }
                if (this.isTraVourse == 1) {
                    if (this.isList == 0) {
                        this.replace('/trainDetail', { trainId: this.trainId })
                    } else {
                        this.replace('/traCourse', { isSx: 1 })
                    }
                }
            }
        },
    }
};
</script>
<style scoped>
.course-container {
    width: 100%;
    background: #f5f7fa;
    border-radius: 8px;
    padding: 10px 10px 0;
}

/* 顶部导航栏 */
.top-nav {
    display: flex;
    align-items: center;
    width: 100%;
    height: 48px;
    padding: 0 16px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 1px 4px rgba(15, 35, 95, 0.06);
    box-sizing: border-box;
}

.back-container {
    display: flex;
    align-items: center;
    gap: 4px;
    height: 32px;
    padding: 0 10px;
    border-radius: 6px;
    cursor: pointer;
    color: #606266;
    font-size: 14px;
    flex-shrink: 0;
    transition: all 0.2s;
}

.back-container:hover {
    color: var(--el-color-primary);
    background: #f0f4fa;
}

.top-nav-title {
    margin-left: 12px;
    padding-left: 12px;
    border-left: 1px solid #e4e7ed;
    font-size: 15px;
    font-weight: 600;
    color: #303133;
}

.course-main {
    position: relative;
    margin-top: 10px;
}

/* 左侧操作栏 */
.side-bar {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
    height: calc(100vh - 170px);
    font-size: 13px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 1px 4px rgba(15, 35, 95, 0.06);
}

.side-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 8px 2px;
    border-radius: 8px;
    color: #606266;
    transition: all 0.2s;
}

.side-item:hover {
    background: #f0f4fa;
}

.side-item img {
    width: 24px;
}

.side-item .side-item-img-lg {
    width: 30px;
}

.side-item-label {
    margin-top: 6px;
    text-align: center;
    max-width: 100%;
}

.side-item-active {
    color: var(--el-color-primary);
}

/* 章节目录悬浮面板 */
.btx {
    width: 320px;
    position: absolute;
    left: calc(4.1667% + 8px);
    top: 0;
    z-index: 999;
    opacity: 1;
    transition: opacity 0.2s ease;
}

.btx-hide {
    opacity: 0;
    width: 0;
    pointer-events: none;
}

.chapter-panel {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 170px);
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 16px rgba(15, 35, 95, 0.12);
    overflow: hidden;
}

.chapter-panel-header {
    flex-shrink: 0;
    padding: 12px 16px;
    font-size: 15px;
    font-weight: 600;
    color: #303133;
    border-bottom: 1px solid #f0f0f0;
}

.chapter-panel-body {
    flex: 1;
    overflow: auto;
    padding: 8px;
}

.custtoo /deep/ .el-tree-node__label {
    flex: 1;
}

/* 视频与评论区 */
.video-card {
    height: calc(100vh - 170px);
    overflow: auto;
    position: relative;
    border: none;
    border-radius: 8px;
    margin: 0 10px;
}

.video-card /deep/ .el-card__body {
    padding: 16px;
}

.ci-video-box {
    width: 100%;
    height: auto;
    background: #000;
    border-radius: 6px;
    overflow: hidden;
}

.node-tag-list {
    display: flex;
}

.node-tag-name {
    font-weight: bold;
    color: #000;
}

.comment-header {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-top: 16px;
    padding-bottom: 8px;
    border-bottom: 1px solid #f0f0f0;
    font-size: 15px;
    font-weight: 600;
    color: #303133;
}

.comment-item {
    margin-top: 15px;
    padding-bottom: 12px;
    border-bottom: 1px solid #f5f5f5;
}

.comment-item-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.comment-user {
    display: flex;
    align-items: center;
    color: #606266;
}

.comment-user-name {
    margin-left: 10px;
}

.comment-del {
    margin-right: 15px;
    color: #909399;
}

.comment-del:hover {
    color: var(--el-color-danger);
}

.comment-content {
    padding-left: 42px;
    color: #303133;
    line-height: 1.6;
}

.comment-time {
    padding-left: 42px;
    margin-top: 5px;
    color: #909399;
    font-size: 12px;
}

.comment-input {
    margin-top: 12px;
}

.comment-send {
    width: 100%;
    padding: 5px 20px;
    display: flex;
}

/* 右侧课程信息 */
.info-panel {
    height: calc(100vh - 170px);
    overflow: auto;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 1px 4px rgba(15, 35, 95, 0.06);
    padding: 16px;
}

.info-user {
    display: flex;
    align-items: center;
}

.info-user-name {
    margin-left: 10px;
    font-size: 15px;
    font-weight: 600;
    color: #303133;
}

.info-recommend {
    margin-top: 10px;
    font-size: 14px;
    color: #606266;
    line-height: 1.7;
}

.info-section-title {
    margin-top: 24px;
    padding-left: 8px;
    border-left: 3px solid var(--el-color-primary);
    font-size: 15px;
    font-weight: 600;
    color: #303133;
    line-height: 1.2;
}

.ci-video-item {
    margin-top: 12px;
    padding: 6px;
    border-radius: 6px;
    transition: background 0.2s;
}

.ci-video-item:hover {
    background: #f5f7fa;
}

.ci-video-item-cover {
    border-radius: 6px;
    overflow: hidden;
}

.csvideo {
    display: block;
    width: 100%;
    height: 140px;
    object-fit: cover;
}

.ci-video-item-title {
    margin-top: 6px;
    font-size: 14px;
    color: #303133;
}

.ci-video-item-active {
    background: #f0f4fa;
}

.ci-video-item-active .ci-video-item-cover {
    box-shadow: 0 0 0 2px var(--el-color-primary);
}

.ci-video-item-active .ci-video-item-title {
    color: var(--el-color-primary);
}

/* 附件弹窗 */
.ci-file-list {
    display: flex;
    flex-wrap: wrap;
}

.ci-file-item {
    margin: 12px;
    border: 1px solid #ebeef5;
    border-radius: 8px;
    overflow: hidden;
    transition: box-shadow 0.2s;
}

.ci-file-item:hover {
    box-shadow: 0 4px 12px rgba(15, 35, 95, 0.12);
}

.ci-file-item-img {
    display: block;
    width: 250px;
    height: 300px;
    object-fit: cover;
}

.ci-file-item-name {
    width: 250px;
    padding: 8px;
    text-align: center;
    color: #303133;
    box-sizing: border-box;
}

.csbbb {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    position: relative;
}

.eicon {
    display: none;
    position: absolute;
    top: 8px;
    right: 8px;
    padding: 5px;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 4px;
    cursor: pointer;
    z-index: 99;
}

.csbbb:hover .eicon {
    display: block;
}

/deep/ .el-input-group__append {
    background: var(--el-color-primary);
    color: #fff;
}

.zsss /deep/ .el-input-group__append {
    padding: 0px !important;
}

/deep/ .el-dialog__body {
    padding: 10px 20px !important;
}
</style>
